export default "__VITE_ASSET__BQFcC0Jc__"